import React, { FC } from 'react';

interface IProps {
  className?: string;
}

const IconDownload: FC<IProps> = ({ className }) => {
  return (
    <>
      <svg
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 10V1M7.5 1L3.5 4.27645M7.5 1L11.5 4.37884"
          stroke="white"
          strokeLinejoin="round"
        />
        <path d="M14.5 11V16H0.5V11" stroke="white" />
      </svg>
    </>
  );
};

export default IconDownload;
